import React from 'react';
import UItem from '../../item';

import TextAreaItem from './textAreaItem';

import { InputProps, DefaultValueList } from '../type.d';

// 表单 输入框组件
function GroupTextArea(props: InputProps) {
  const {
    prefixCls = 'crm-input',
    itemType = 'textarea',
    type,
    value,
    disabled,
    defaultValue,
    rows,
    autoHeight,
    maxLength,
    clearable,
    showLength,
    placeholder,
    readOnly,
    readonly,
    hiddenElem,
    description,
    _crengine,
    onChange,
    onLog,
    options,
    ...rest
  } = props;
  const newReadOnly = (readOnly || readonly);

  const onValueChange = (value:any) => {
    const { onChange, ...rest } = props;

    if (onChange) {
      onChange({
        ...rest,
        value,
      });
    }
  };

  const getDefaultValue = () => {
    const { options, defaultValue } = props;
    if (defaultValue) {
      return defaultValue as unknown as DefaultValueList[];
    }
    return options.map((item) => {
      const { dataBind, name, defaultValue: childDefaultValue} = item;
      return {
        name: dataBind || name,
        value: childDefaultValue || ''
      };
    });
  };

  const { value: newValue, ...newRest} = props;

  return (
    <UItem
      itemType={itemType}
      readOnly={newReadOnly}
      {...rest}
      _crengine={_crengine}
      initialValue={getDefaultValue() || ''}
      validateTrigger="onBlur"
    >
      <TextAreaItem 
        {...newRest}
        valueList={newValue as unknown as DefaultValueList[]}
        onChange={(value) => onValueChange(value)}
        defaultValueList={getDefaultValue()}
      />
    </UItem>
  );
}

export default GroupTextArea;
